import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import template from 'lodash/template';
/**
 * Gets various attributes related to the conversation message delivery status.
 *
 * @param status The delivery status type.
 */
export function getConversationMessageDeliveryStatusAttributes(status) {
    var _a;
    return ((_a = conversationMessageDeliveryStatusAttributes[status]) !== null && _a !== void 0 ? _a : conversationMessageDeliveryUnknownStatusAttributes);
}
/** Represents the conversation message delivery status type attributes. */
export const conversationMessageDeliveryStatusAttributes = {
    info: {
        icon: _jsx(Icon, { color: typography.color.tertiary, name: "info" }),
        labelTemplate: 'Info',
    },
    delivered: {
        icon: _jsx(Icon, { color: typography.color.tertiary, name: "check-circle-filled" }),
        labelTemplate: template('Delivered to ${contact}'),
    },
    failed: {
        icon: _jsx(Icon, { color: typography.color.error, name: "close-circle-filled" }),
        labelTemplate: template('Delivery failed to ${contact}'),
    },
    seen: {
        icon: (_jsx(Icon, { color: typography.color.tertiary, name: "double-check-circle-filled" })),
        labelTemplate: template('Read by ${contact}'),
    },
    sent: {
        icon: _jsx(Icon, { color: typography.color.tertiary, name: "check-circle" }),
        labelTemplate: template('Sent to ${contact}'),
    },
    spam: {
        icon: (_jsx(Icon, { color: typography.color.warning, name: "exclamation-circle-filled" })),
        labelTemplate: template('Marked as spam by ${contact}'),
    },
};
export const conversationMessageDeliveryUnknownStatusAttributes = {
    icon: _jsx(Icon, { color: typography.color.tertiary, name: "question" }),
    labelTemplate: 'Unknown status',
};
